import { AlertTriggerType } from 'xm-constants/triggerTypes';

/**
 * getSubtriggerHeight gives a hacky best guess at the height of the new trigger.
 * Actually measuring the node would add a lot of complexity and timing issues, so
 * these estimates are seen as the lesser evil.
 */
export const DEFAULT_SUB_TRIGGER_HEIGHT = 167;
export const getSubtriggerHeight = trigger => {
  if (trigger.id === AlertTriggerType.RESPONSE) {
    const childrenLength = trigger.responses?.length || 0;
    return 195 + childrenLength * DEFAULT_SUB_TRIGGER_HEIGHT;
  }
  return DEFAULT_SUB_TRIGGER_HEIGHT;
};
